import React from "react";
import { ReactComponent as EmptyLogsScreen } from "assets/images/app_svg/activities_empty.svg";

function EmptyLogs() {
  return (
    <div class="web_logs_empty">
      <div class="web_logs_empty_screen">
        <div class="img_holder flex_center">
          <EmptyLogsScreen />
        </div>
        <p>No activities to view</p>
      </div>
    </div>
  );
}
export default EmptyLogs;
